import React, { useState } from "react";
import "./ContactUs.css";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../redux/reducers/root";
import { LiveChatState } from "../../redux/reducers/getLiveChatReducer/liveChatReducer";
import { getChatStatus, setChatState } from "../../redux/actions/livechat/livechat";
import AmpInlineLoadingSpinner from "../../components/common/AmpInlineLoadingSpinner/AmpInlineLoadingSpinner";
export default function ContactUs(): JSX.Element {

    const dispatch = useDispatch()
    const { t } = useTranslation('login');
    const liveChatState = useSelector((state: RootState) => state.chatReducer.livechat as LiveChatState);
    const [liveChatChecked, setLiveChatChecked] = useState(false);

    if (!liveChatChecked) {
        dispatch(getChatStatus())
        dispatch(setChatState(true))
        setLiveChatChecked(true);
    }

    const chatEnabled = liveChatState.enabled;
    const chatTranslationName = chatEnabled ? "live-chat" : "live-chat-disabled"
    const hasTranslation = t(chatTranslationName) !== chatTranslationName;
    const chatEnalbed = process.env?.REACT_APP_NEW_CHAT_ENABLED;
    return (
        <>
            <div className={"contact"}>
                <div className="contact-main">
                    <span><h1>{t("contact") as string}</h1></span>
                    <p>{t("contact-description") as string}</p>
                </div>
                {hasTranslation &&
                    <>
                        {chatEnalbed !== "1" ?
                            <a href="https://www.mpac.ca/en/ampbridge" className={chatEnabled ? "chat-link" : "chat-off"} target="_blank" rel="noreferrer noopener">
                                <div className="contact-chat">
                                    <div className="livechat-status-container">
                                        <h2>{t(chatTranslationName) as string}</h2>
                                        {liveChatState.loading && <AmpInlineLoadingSpinner></AmpInlineLoadingSpinner>}
                                    </div>

                                    <img src="/images/ls_big_girl_off.png" alt="contact img"></img>
                                </div>
                            </a> :
                            <div onClick={() => window.toggleMessenger()} className={chatEnabled ? "chat-link" : "chat-off"}>
                                <div className="contact-chat">
                                    <div className="livechat-status-container">
                                        <h2>{t(chatTranslationName) as string}</h2>
                                        {liveChatState.loading && <AmpInlineLoadingSpinner></AmpInlineLoadingSpinner>}
                                    </div>
                                    <img src="/images/ls_big_girl_off.png" alt="contact img"></img>
                                </div>
                            </div>
                        }
                    </>

                }

                <div className={"contact-email"}>
                    <h2>{t("email") as string}</h2>
                    <a className="amp-anchor blue" href={t("contact-us-link")} target="_blank" rel="noreferrer noopener">
                        <p>{t("email-form") as string}</p>
                    </a>
                </div>
                <div className={"contact-customer"}>
                    <h2>{t("customer-contact") as string}</h2>
                    <p>{t("customer-description") as string}</p>
                    <p>{t("toll-free") as string}<b>{t("contact-number") as string}</b></p>
                    <p><b>{t("contact-number-tty") as string}</b></p>
                    <p>{t("contact-hours") as string}</p>
                    <p>{t("contact-roll-number") as string}</p>
                    {/* <p>
                        <strong>{t("contact-no-tty-heading") as string}</strong>
                        <br/>
                        {t("contact-no-tty") as string}
                    </p> */}
                </div>
            </div >
        </>


    );

}